(function () {
  // Højden på .pd-acc__panel animeres som en målt pixel-værdi i stedet for at
  // læne sig på en CSS-klasse alene. Ved åbning sættes den direkte til scroll-
  // Height, og når overgangen er færdig, sættes den til 'auto' (via transitionend
  // nedenfor), så panelet automatisk følger indhold, der ændrer højde bagefter
  // (fx billeder der loader, eller vinduet der resizes). Ved lukning skal panelet
  // først have en konkret px-højde (ikke 'auto', som ikke kan animeres fra) — den
  // sættes synkront, og i næste frame sættes højden til 0, så browseren har et
  // reelt start- og slutpunkt at transitionere mellem.
  // 'is-closing' er en ekstra klasse (ud over 'is-open') som sektioner kan style
  // efter — fx Program-punkter bruger den til at holde "peek"-linjen (kort
  // sammenfatning) skjult, indtil selve luk-animationen er helt færdig, så
  // peek-linjen og den fulde beskrivelse ikke et kort øjeblik er synlige på
  // samme tid ("dublet tekst"). Den sættes synkront i samme kald som selve
  // luk-beslutningen (ikke via en efterfølgende MutationObserver, som kan nå
  // at overlappe med en efterfølgende hurtig gen-åbning/-lukning), og ryddes
  // både via transitionend (normalt) og en backup-timer (hvis en transition
  // bliver afbrudt/aldrig affyrer transitionend — fx ved meget hurtige klik).
  var CLOSE_MS = 320; // 240ms CSS-transition + buffer

  function setOpen(item, btn, open) {
    if (btn && btn.hasAttribute('disabled')) return;
    if (item.classList.contains('is-open') === open) return;
    var panel = item.querySelector(':scope > .pd-acc__panel') || item.querySelector('.pd-acc__panel');
    item.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (item.__pdCloseTimer) {
      clearTimeout(item.__pdCloseTimer);
      item.__pdCloseTimer = null;
    }
    if (!panel) return;

    if (open) {
      item.classList.remove('is-closing');
      panel.style.height = panel.scrollHeight + 'px';
    } else {
      item.classList.add('is-closing');
      item.__pdCloseTimer = setTimeout(function () {
        item.classList.remove('is-closing');
        item.__pdCloseTimer = null;
      }, CLOSE_MS);
      var current = panel.style.height;
      if (!current || current === 'auto') {
        panel.style.height = panel.scrollHeight + 'px';
      }
      requestAnimationFrame(function () {
        panel.style.height = '0px';
      });
    }
  }

  function openAll(root, open) {
    root.querySelectorAll('.pd-acc__item').forEach(function (item) {
      var btn = item.querySelector('[data-pd-acc-toggle]');
      if (btn && btn.hasAttribute('disabled')) return;
      setOpen(item, btn, open);
    });
  }

  function syncToggleAllLabel(root) {
    var allBtn = root.parentElement && root.parentElement.querySelector('[data-pd-acc-toggle-all]');
    if (!allBtn) return;
    var anyClosed = !!root.querySelector('.pd-acc__item:not(.is-open)');
    allBtn.textContent = anyClosed ? allBtn.dataset.labelOpen : allBtn.dataset.labelClose;
  }

  function init(root) {
    if (root.dataset.pdAccInit === 'true') return;
    root.dataset.pdAccInit = 'true';
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pd-acc-toggle]');
      if (!btn || !root.contains(btn)) return;
      var item = btn.closest('.pd-acc__item');
      if (!item || !root.contains(item) || item.parentElement.closest('[data-pd-acc-root]') !== root) return;
      e.stopPropagation();
      var open = !item.classList.contains('is-open');
      setOpen(item, btn, open);
      syncToggleAllLabel(root);
    });

    // Når en panel-højde er færdig med at animere ind, sættes den til 'auto',
    // så den ikke låser til en forældet px-værdi, hvis indholdet ændrer højde
    // senere (billed-load, vindues-resize, en indlejret accordion der åbnes).
    // Når en luk-animation er færdig, ryddes 'is-closing' med det samme (i
    // stedet for at vente på backup-timeren i setOpen) — men kun hvis panelet
    // stadig faktisk er lukket; er det blevet åbnet igen i mellemtiden, er
    // 'is-closing' allerede ryddet af setOpen, og dette gør ingenting.
    root.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'height') return;
      var panel = e.target;
      if (!panel.classList || !panel.classList.contains('pd-acc__panel')) return;
      var item = panel.closest('.pd-acc__item');
      if (!item) return;
      if (item.classList.contains('is-open')) {
        panel.style.height = 'auto';
      } else if (panel.style.height === '0px') {
        item.classList.remove('is-closing');
        if (item.__pdCloseTimer) {
          clearTimeout(item.__pdCloseTimer);
          item.__pdCloseTimer = null;
        }
      }
    });
  }

  function initToggleAll(btn) {
    if (btn.dataset.pdAccAllInit === 'true') return;
    btn.dataset.pdAccAllInit = 'true';
    btn.dataset.labelOpen = btn.dataset.labelOpen || btn.textContent.trim();
    btn.dataset.labelClose = btn.dataset.labelClose || 'Fold sammen';
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.pd-acc__head') || btn.parentElement;
      var root = wrap && wrap.parentElement ? wrap.parentElement.querySelector('[data-pd-acc-root]') : null;
      if (!root) return;
      var anyClosed = !!root.querySelector('.pd-acc__item:not(.is-open)');
      openAll(root, anyClosed);
      btn.textContent = anyClosed ? btn.dataset.labelClose : btn.dataset.labelOpen;
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pd-acc-root]').forEach(init);
    document.querySelectorAll('[data-pd-acc-toggle-all]').forEach(initToggleAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-pd-acc-root]').forEach(init);
    e.target.querySelectorAll('[data-pd-acc-toggle-all]').forEach(initToggleAll);
  });

  // Global: pills/links that should expand a target section's accordion (e.g. the "Program" quick-jump pill).
  if (!window.__pdAccExpandTargetInit) {
    window.__pdAccExpandTargetInit = true;
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-pd-expand-target]');
      if (!link) return;
      var targetSection = document.getElementById(link.getAttribute('data-pd-expand-target'));
      if (!targetSection) return;
      var root = targetSection.querySelector('[data-pd-acc-root]');
      if (!root) return;
      openAll(root, true);
      syncToggleAllLabel(root);
    });
  }
})();
